export default __webpack_public_path__ + "static/media/bonus-2.093eedf7.png";